export function getBase64(file, onCompleted) {
  const reader = new FileReader()
  reader.addEventListener("load", () => onCompleted(reader.result))
  reader.readAsDataURL(file)
}

export function downloadStringAsFile(content?: string, filename?: string) {
  const element = document.createElement("a")
  const file = new Blob([content], {
    type: filename.endsWith("json") ? "application/json" : "text/plain",
  })
  element.href = URL.createObjectURL(file)
  element.download = filename
  document.body.appendChild(element)
  element.click()
  document.removeChild(element)
}
